export default class StageConstants {
  public static readonly stageMap: Map<string, string> = new Map<
    string,
    string
  >([
    ['SCM', 'scene-management'],
    ['EQM', 'equipment'],
    ['PRF', 'personnel-profiles'],
    ['DOC', 'documents'],
    ['WNT', 'witness-interviews'],
    ['BST', 'best-practice']
  ])

  public static getKeyByValue(value: string): string {
    const keys = [...this.stageMap].find(([key, val]) => val === value)
    return keys ? keys[0] : ''
  }
}
